import {MainRequest, Status} from 'Services/common';

export interface PlansService {
    id: string;
    name: string;
}
export interface PlansData {
    code: string;
    createTime: string;
    createUser: string;
    remark: string; //说明
    id: string;
    name: string; //名称
    serviceList: PlansService[]; //服务范围
    status: Status; //状态
    updateTime: string;
    type: PlansType; //方案
}
export interface GetPlansProps extends PaginationAntD {
    name: string;
    status: Status;
    type: string;
}
export function getPlansPage(params?: GetPlansProps) {
    return MainRequest.post<PagedSuccessData<PlansData[]>>(
        '/serviceVersion/page',
        {
            ...params,
            pageNo: params?.current,
            pageSize: params?.pageSize,
        },
    )
        .then(res => res.data.data)
        .then(res => {
            return {
                total: res.total,
                data: res.data,
            };
        });
}

//详情
export function getPlansDetail(id: string) {
    return MainRequest.post<SuccessData<PlansData>>('/serviceVersion/detail', {
        id,
    })
        .then(res => res.data.data)
        .then(res => {
            return {
                ...res,
                serviceArray: res.serviceList.map(item => item.id),
            };
        });
}

//保存
export interface SavePlansProps {
    id?: string;
    name: string;
    type: string;
    expireType: string;
    serviceArray: string[];
    maxUserNumber: number;
    remark: string;
}
export function savePlansDetail(data: SavePlansProps) {
    const o = {
        ...data,
        maxUserNumber: data?.maxUserNumber?.toString(),
    };
    return MainRequest.post('/serviceVersion/save', o);
}

//启用停用
export function ChangePlansStatus(id: string, status: Status) {
    return MainRequest.post('/serviceVersion/changeStatus', {
        id,
        status,
    });
}

export enum PlansType {
    Package = 'SHMETP10000101',
    Expansion = 'SHMETP10000102',
    BigData = 'SHMETP10000103',
    Sms = 'SHMETP10000104',
    Storage = 'SHMETP10000105',
}
